
import { Box, Divider, Grid, TableCell, TableContainer, Paper, TableBody, TableRow, Table, TableHead, Typography, Autocomplete, TextField, useTheme, Button, Toolbar } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import 'dayjs/plugin/customParseFormat';

import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Cancel from '@mui/icons-material/CancelOutlined';

import CustomTableContainer from "../../../components/table/CustomTableContainer";
import useMaterialList from "../../../hooks/useMaterialList";
import useBillOfMaterialCode from "../../../hooks/useBillofMaterialCode";
import useBillOfMaterialPlanCode from "../../../hooks/useBillOfMaterialPlanCode.js";

import useProductList from "../../../hooks/useProductList";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

// Sample raw material options
const rawMaterials = [
    { label: "Wood Pulp" },
    { label: "Recycled Paper" },
    { label: "Cotton Linters" },
    { label: "Bagasse" },
    { label: "Straw Pulp" },
];

const layerColors = ["#f9a825", "#0277bd", "#f06292", "#f57c00"]; // Colors for different layers



const AddBillOfMaterial = ({ handlecallback, editMaterialID, setEditMaterialID }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [value, setValue] = React.useState(0);

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    // List of Parameter

    const [materialName, setMaterialName] = useState('');
    const [minimumReOrderQty, setMinimumReOrderQty] = useState(0);

    const [leadTimeDemand, setLeadTimeDemand] = useState(0);
    const [safetyStock, setSafetyStock] = useState(0);
    const [vendors, setVendors] = useState([]);

    const { materialCode, setMaterialCode, loadMaterialCodeByID } = useBillOfMaterialCode(editMaterialID);
    const { materialPlanCode, setMaterialPlanCode, loadMaterialPlanCodeByID } = useBillOfMaterialPlanCode(editMaterialID);
    const { materialList, setMaterialList, selectMaterial, selectMaterialID, loadMaterialListByID, } = useMaterialList();
    const { productList, selectedProduct, selectedProductID, setSelectedProduct, setSelectedProductID, loadProductByID, } = useProductList(editMaterialID);

    const [selectedMaterial, setSelectedMaterial] = useState(null);

    const [rawMaterialRows, setRawMaterialRows] = useState([]); // Stores dynamic rows
    const [chemicalMaterialRows, setChemicalMaterialRows] = useState([]); // Stores dynamic rows
    const [fuelMaterialRows, setFuelMaterialRows] = useState([]);

    // Function to add a new row
    const addRawMaterialRow = () => {
        setRawMaterialRows([
            ...rawMaterialRows,
            {
                id: rawMaterialRows.length + 1,
                material: null,
                id_material: 0,
                yield: "",
                layers: [
                    { furnish: "", tonsPerTon: "" },
                    { furnish: "", tonsPerTon: "" },
                    { furnish: "", tonsPerTon: "" },
                    { furnish: "", tonsPerTon: "" }
                ] // Only "Furnish" fields for each layer
            }
        ]);
    };

    // Function to update row values
    const updateRow = (index, field, value) => {
        const updatedRows = [...rawMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.furnish ? (parseFloat(layer.furnish / yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setRawMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...rawMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;
        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const furnishValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].tonsPerTon = furnishValue ? (furnishValue / yieldValue).toFixed(3) : "";
        setRawMaterialRows(updatedRows);
    };

    // Calculate summary values for each layer
    const summary = rawMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.furnish[i] += parseFloat(layer.furnish) || 0;
                acc.tonsPerTon[i] += parseFloat(layer.tonsPerTon) || 0;
            });
            return acc;
        },
        { furnish: [0, 0, 0, 0], tonsPerTon: [0, 0, 0, 0] }
    );


    // Function to add a new row
    const addChemicalRow = () => {
        setChemicalMaterialRows([
            ...chemicalMaterialRows,
            {
                id: chemicalMaterialRows.length + 1,
                material: null,
                id_material: 0,
                yield: "100",
                layers: [
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                ] // Only "Furnish" fields for each layer
            }
        ]);
    };

    // Function to update row values
    const updateChemicalRow = (index, field, value) => {
        const updatedRows = [...chemicalMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.dosage ? (parseFloat(layer.dosage * yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setChemicalMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateChemicalLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...chemicalMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;
        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const dosageValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].kgPerTon = dosageValue ? ((dosageValue / yieldValue) * 100).toFixed(1) : "";
        setChemicalMaterialRows(updatedRows);
    };

    // Calculate summary values for each layer
    const chemicalSummary = chemicalMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.dosage[i] += parseFloat(layer.dosage) || 0;
                acc.kgPerTon[i] += parseFloat(layer.kgPerTon) || 0;
            });
            return acc;
        },
        { dosage: [0, 0, 0, 0], kgPerTon: [0, 0, 0, 0] }
    );

    //fuel

    const addFuelRow = () => {
        setFuelMaterialRows([
            ...fuelMaterialRows,
            {
                id: fuelMaterialRows.length + 1,
                material: null,
                id_material: 0,
                yield: "100",
                layers: [
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                    { dosage: "", kgPerTon: "" },
                ] // Only "Furnish" fields for each layer
            }
        ]);
    };

    // Function to update row values
    const updateFuelRow = (index, field, value) => {
        const updatedRows = [...fuelMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.dosage ? (parseFloat(layer.dosage * yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setFuelMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateFuelLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...fuelMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;
        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const dosageValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].kgPerTon = dosageValue ? ((dosageValue / yieldValue) * 100).toFixed(1) : "";
        setFuelMaterialRows(updatedRows);
    };

    // Calculate summary values for each layer
    const fuelSummary = fuelMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.dosage[i] += parseFloat(layer.dosage) || 0;
                acc.kgPerTon[i] += parseFloat(layer.kgPerTon) || 0;
            });
            return acc;
        },
        { dosage: [0, 0, 0, 0], kgPerTon: [0, 0, 0, 0] }
    );


    const [rawMaterial, setRawMaterial] = useState([]);
    const [chemicalMaterial, setChemicalMaterial] = useState([]);
    const [fuelMaterial, setFuelMaterial] = useState([]);
    useEffect(() => {

        if (materialList.length > 0) {
            // Get raw material list
            const raw = materialList.filter((r) => r.category_desc === 'RAW MATERIAL');
            setRawMaterial(raw);

            // Get chemical material list
            const chemicalraw = materialList.filter((r) => r.category_desc === 'CHEMICAL AND DYES');
            setChemicalMaterial(chemicalraw);

            // Get fuel material list
            const fuelraw = materialList.filter((r) => r.category_desc === 'FUEL');
            setFuelMaterial(fuelraw);
        }


    }, [materialList]);


    // List of Parameter
    const [isLoadEditPO, setLoadEditPO] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            if (!isLoadEditPO && editMaterialID != 0) {
                try {
                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_bom: editMaterialID,
                    };

                    const billOfMaterialResponse = await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
                    // const billOfMaterialResponse = await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
                    const billOfMaterialDet = billOfMaterialResponse[0];

                    const productPara = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, };


                    const [billOfMaterialData] = await Promise.all([
                        callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),

                    ]);


                    if (billOfMaterialData && billOfMaterialData.length > 0) setMaterialList(billOfMaterialData);

                    if (billOfMaterialDet) {
                        setMaterialCode(billOfMaterialDet.bom_code);
                        setMaterialPlanCode(billOfMaterialDet.bom_code);
                        loadProductByID(billOfMaterialDet.productvariety_id);

                        const productData = typeof billOfMaterialDet.bomitem_list === "string"
                            ? JSON.parse(billOfMaterialDet.bomitem_list)
                            : billOfMaterialDet.bomitem_list;

                        if (Array.isArray(productData)) {
                            const mappedRows = productData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || "",
                                id_material: item.id_material,
                            }));

                            setRawMaterialRows(mappedRows);
                        } else {
                            setRawMaterialRows([]);
                        }

                        // const chemicalData = typeof billOfMaterialDet.bom_chemical_list === 'string'
                        //     ? JSON.parse(billOfMaterialDet.bom_chemical_list)
                        //     : billOfMaterialDet.bom_chemical_list;

                        const chemicalData = typeof billOfMaterialDet.bom_chemical_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_chemical_list)
                            : billOfMaterialDet.bom_chemical_list;

                        if (Array.isArray(chemicalData)) {
                            const mappedRows = chemicalData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setChemicalMaterialRows(mappedRows);
                        } else {
                            setChemicalMaterialRows([]);
                        }


                        const fuelData = typeof billOfMaterialDet.bom_fuel_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_fuel_list)
                            : billOfMaterialDet.bom_fuel_list;

                        if (Array.isArray(fuelData)) {
                            const mappedRows = fuelData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setFuelMaterialRows(mappedRows);
                        } else {
                            setFuelMaterialRows([]);
                        }

                        await loadProductByID(billOfMaterialDet.productvariety_id);

                    }
                } catch (error) {
                    callMessage('error', error.message, 'Error');
                }
            }
        };

        fetchData();
    }, [isLoadEditPO, editMaterialID]);


    const callback = () => {
        handlecallback();
    }

    const [hideAdd, setHideAdd] = useState(true);
    const [hideSave, setHideSave] = useState(false);

    const handleAddNewMaterial = () => {
        setEditMaterialID(0);
        setMinimumReOrderQty(0);
        setSafetyStock(0);
        setLeadTimeDemand(0);
        setVendors([]);
        setMaterialName('');
        setHideAdd(true);
        // setMinimumReOrderLevel(0);
        setHideSave(false);
    }

    const handleSaveAndDraft = () => {

        let company_id = localStorage.getItem('companyid');
        let user = localStorage.getItem('userID');
        let selectedmode = editMaterialID === 0 ? 0 : 1;
        let id_material = editMaterialID === 0 ? 0 : editMaterialID;
        let date = new Date().toISOString().split('T')[0];

        // Validation checks
        if (!company_id) {
            callMessage('error', 'Company ID is required', 'Error');
            return;
        }
        const requestBody = {
            p_companyid: company_id,
            p_plantid: 1,
            p_mode: selectedmode,
            p_id_bom: id_material,
            p_bom_code: materialPlanCode,//materialCode,
            p_bom_date: dayjs(date).format('YYYY-MM-DD hh:mm:ss'), // Sets current date in 'YYYY-MM-DD' format
            p_createdby: user,
            p_productvariety_id: selectedProductID,
            p_status: 'Active',
            p_bomitem_list: rawMaterialRows,
            p_bom_chemical_list: chemicalMaterialRows,
            p_bom_fuel_list: fuelMaterialRows,
        }
//BILL_MATERIAL_GRUD_PROCESS
        callApi(API_ENDPOINTS.BILL_MATERIAL_GRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                if (data && data.length > 0) {
                    let msg = editMaterialID === 0 ? 'New BOM Added Successfully' : 'BOM Updated Successfully';
                    setHideSave(true);
                    setHideAdd(false);
                    callMessage('info', msg, 'info');
                }
            })
            .catch(error => { callMessage('error', error.message, 'Error'); });
    };

    // convert bom to request indent
    // const ConvertBOMtoRequestIndent = () => {
    //     let rawMaterialList = rawMaterialRows;
    //     let chemicalList = chemicalMaterialRows;
    // }


    return (<>


        <Box padding={0}>

            <Header title={editMaterialID == 0 ? 'New Bill Of Material' : 'Edit Bill Of Material'} subtitle="" callback={callback} />
            <Divider />

            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


            <ResponsiveBox
                customMaxHeight={{
                    xs: '72vh', // Extra small devices (phones)
                    sm: '72vh', // Small devices (tablets)
                    md: '74vh', // Medium devices (small laptops)
                    lg: '74vh', // Large devices (desktops)
                    xl: '82vh', // Extra large devices (large desktops)
                }}>

                <Grid container  >
                    <Grid item xs={12} xl={12} >

                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                            <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center">
                                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Bill Of Material Code
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                {/* <TextField value={materialCode} fullWidth size="small" label="" required variant="outlined" /> */}
                                <TextField value={materialPlanCode} fullWidth size="small" label="" required variant="outlined" />
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} xl={12} >
                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                            <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Product Name
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    options={productList}
                                    value={selectedProduct}
                                    onChange={(event, newValue) => {
                                        setSelectedProduct(newValue);
                                        setSelectedProductID(newValue.id);

                                    }}
                                    getOptionLabel={(option) => option.varietycode || ''}
                                    renderInput={(params) => (
                                        <TextField {...params} label="" placeholder="select Product" required variant="outlined" />
                                    )}
                                />
                            </Grid>

                        </Grid>
                    </Grid>


                    <Grid item xs={12} xl={12}  >
                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                            <CustomTableContainer colors={colors}>
                                <TableContainer component={Paper} >

                                    <Table aria-label="BOM Table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                <TableCell rowSpan={2} align="center"><strong>Raw Material</strong></TableCell>
                                                {/* <TableCell rowSpan={2}><strong>Cost / ton</strong></TableCell> */}
                                                <TableCell rowSpan={2} align="center">
                                                    <strong>Yield</strong>
                                                    <br />
                                                    {/* A = (100% - B - C) */}
                                                </TableCell>

                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                    <TableCell key={layer} colSpan={2} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                        <strong>{layer}</strong>
                                                    </TableCell>
                                                ))}
                                            </TableRow>

                                            <TableRow>
                                                {/* Columns for each layer */}
                                                {["Furnish", "tons/ton"].map((label) => (
                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#f9a825" }}>{label}</TableCell>
                                                ))}
                                                {["Furnish", "tons/ton"].map((label) => (
                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#0277bd" }}>{label}</TableCell>
                                                ))}
                                                {["Furnish", "tons/ton"].map((label) => (
                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#f06292" }}>{label}</TableCell>
                                                ))}
                                                {["Furnish", "tons/ton"].map((label) => (
                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#f57c00" }}>{label}</TableCell>
                                                ))}
                                            </TableRow>

                                        </TableHead>
                                        <TableBody>
                                            {/* Data rows can be added here */}
                                            {rawMaterialRows.map((row, index) => (
                                                <TableRow key={row.id}>
                                                    <TableCell align="center">{row.id}</TableCell>
                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }} >
                                                        <Autocomplete
                                                            sx={{
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: '4px',
                                                                    textAlign: 'left',
                                                                },
                                                            }}
                                                            options={rawMaterial}
                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                            value={row.material}
                                                            onChange={(event, newValue) => updateRow(index, "material", newValue)}
                                                            renderInput={(params) => (
                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                            )}
                                                            size="small"
                                                        />
                                                    </TableCell>


                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                    {["yield"].map((field) => (
                                                        <TableCell key={field}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={row[field]}
                                                                onChange={(e) => updateRow(index, field, e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ))}


                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                        <TableCell key={`furnish-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={layer.furnish}
                                                                onChange={(e) => updateLayer(index, layerIndex, "furnish", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>,
                                                        <TableCell key={`tonsPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}
                                                                type="number"
                                                                value={layer.tonsPerTon}
                                                                onChange={(e) => updateLayer(index, layerIndex, "tonsPerTon", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ])}

                                                </TableRow>
                                            ))}
                                            {/* Summary Row */}
                                            <TableRow>
                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                {summary.furnish.map((total, layerIndex) => (
                                                    <React.Fragment key={layerIndex}>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{total.toFixed(2)}</strong>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{summary.tonsPerTon[layerIndex].toFixed(2)}</strong>
                                                        </TableCell>
                                                    </React.Fragment>
                                                ))}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Button onClick={addRawMaterialRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Raw Material
                                    </Button>
                                </TableContainer>
                            </CustomTableContainer>

                        </Grid>
                    </Grid>

                    <Grid item xs={12} xl={12}  >
                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                            <CustomTableContainer colors={colors}>
                                <TableContainer component={Paper} >

                                    <Table aria-label="BOM Table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                <TableCell rowSpan={2} align="center" ><strong>Chemicals</strong></TableCell>
                                                {/* <TableCell rowSpan={2}><strong>Cost / ton</strong></TableCell> */}
                                                <TableCell rowSpan={2} align="center">
                                                    <strong>Yield</strong>
                                                    <br />
                                                    {/* A = (100% - B - C) */}
                                                </TableCell>

                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                    <TableCell key={layer} colSpan={2} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                        <strong>{layer}</strong>
                                                    </TableCell>
                                                ))}
                                            </TableRow>

                                            <TableRow>
                                                {/* Columns for each layer */}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#f9a825" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#0277bd" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#f06292" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "tons/ton"].map((label) => (
                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#f57c00" }}>{label}</TableCell>
                                                ))}
                                            </TableRow>

                                        </TableHead>
                                        <TableBody>
                                            {/* Data rows can be added here */}
                                            {chemicalMaterialRows.map((row, index) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.id}</TableCell>
                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>
                                                        <Autocomplete
                                                            sx={{
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: '4px',
                                                                    textAlign: 'left',
                                                                },
                                                            }}
                                                            options={chemicalMaterial}
                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                            value={row.material}
                                                            onChange={(event, newValue) => updateChemicalRow(index, "material", newValue)}
                                                            renderInput={(params) => (
                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                            )}
                                                            size="small"
                                                        />
                                                    </TableCell>


                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                    {["yield"].map((field) => (
                                                        <TableCell key={field}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={row[field]}
                                                                onChange={(e) => updateChemicalRow(index, field, e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ))}


                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                        <TableCell key={`dosage-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={layer.dosage}
                                                                onChange={(e) => updateChemicalLayer(index, layerIndex, "dosage", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>,
                                                        <TableCell key={`kgPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}
                                                                type="number"
                                                                value={layer.kgPerTon}
                                                                onChange={(e) => updateChemicalLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ])}

                                                </TableRow>
                                            ))}
                                            {/* Summary Row */}
                                            <TableRow>
                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                {chemicalSummary.dosage.map((total, layerIndex) => (
                                                    <React.Fragment key={layerIndex}>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{total.toFixed(2)}</strong>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{chemicalSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                                        </TableCell>
                                                    </React.Fragment>
                                                ))}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Button onClick={addChemicalRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Chemical
                                    </Button>
                                </TableContainer>
                            </CustomTableContainer>

                        </Grid>
                    </Grid>

                    <Grid item xs={12} xl={12}  >
                        <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                            <CustomTableContainer colors={colors}>
                                <TableContainer component={Paper} >

                                    <Table aria-label="BOM Table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                <TableCell rowSpan={2} align="center" ><strong>Fuels</strong></TableCell>
                                                {/* <TableCell rowSpan={2}><strong>Cost / ton</strong></TableCell> */}
                                                <TableCell rowSpan={2} align="center">
                                                    <strong>Yield</strong>
                                                    <br />
                                                    {/* A = (100% - B - C) */}
                                                </TableCell>

                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                    <TableCell key={layer} colSpan={2} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                        <strong>{layer}</strong>
                                                    </TableCell>
                                                ))}
                                            </TableRow>

                                            <TableRow>
                                                {/* Columns for each layer */}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#f9a825" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#0277bd" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "Kg/ton"].map((label) => (
                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#f06292" }}>{label}</TableCell>
                                                ))}
                                                {["Dosage", "tons/ton"].map((label) => (
                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#f57c00" }}>{label}</TableCell>
                                                ))}
                                            </TableRow>

                                        </TableHead>
                                        <TableBody>
                                            {/* Data rows can be added here */}
                                            {fuelMaterialRows.map((row, index) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.id}</TableCell>
                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>
                                                        <Autocomplete
                                                            sx={{
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: '4px',
                                                                    textAlign: 'left',
                                                                },
                                                            }}
                                                            options={fuelMaterial}
                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                            value={row.material}
                                                            onChange={(event, newValue) => updateFuelRow(index, "material", newValue)}
                                                            renderInput={(params) => (
                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                            )}
                                                            size="small"
                                                        />
                                                    </TableCell>


                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                    {["yield"].map((field) => (
                                                        <TableCell key={field}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={row[field]}
                                                                onChange={(e) => updateFuelRow(index, field, e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ))}


                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                        <TableCell key={`dosage-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}

                                                                type="number"
                                                                value={layer.dosage}
                                                                onChange={(e) => updateFuelLayer(index, layerIndex, "dosage", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>,
                                                        <TableCell key={`kgPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <TextField
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '4px',
                                                                        textAlign: 'center',
                                                                    },
                                                                }}
                                                                type="number"
                                                                value={layer.kgPerTon}
                                                                onChange={(e) => updateFuelLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    ])}

                                                </TableRow>
                                            ))}
                                            {/* Summary Row */}
                                            <TableRow>
                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                {fuelSummary.dosage.map((total, layerIndex) => (
                                                    <React.Fragment key={layerIndex}>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{total.toFixed(2)}</strong>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                            <strong>{fuelSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                                        </TableCell>
                                                    </React.Fragment>
                                                ))}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Button onClick={addFuelRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Fuels
                                    </Button>
                                </TableContainer>
                            </CustomTableContainer>

                        </Grid>
                    </Grid>

                </Grid>
            </ResponsiveBox>



            <Grid container>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                    <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                        <Toolbar>
                            <Button size="small" variant="contained" color="secondary" onClick={handleAddNewMaterial} disabled={hideAdd} startIcon={<AddCircleOutlineIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Add New </Button>
                            <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} disabled={hideSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Save Material</Button>
                            <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                            {/* <Button size="small" variant="contained" color="secondary" onClick={ConvertBOMtoRequestIndent} disabled={hideSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Request Indent</Button> */}
                        </Toolbar>
                    </Box>
                </Grid>
            </Grid>

        </Box>

    </>)
}
export default AddBillOfMaterial;